import { evaluatePhone } from "./requiredStepValidation"

const answered = (value) =>
  value !== undefined && value !== null && value !== ""

export const evaluateAdditionalStep = (
  state,
  quote,
  { includePhone = false } = {}
) => {
  const { additionalInformation } = state

  const missingFieldIds = (quote.contractSigningEnablements || [])
    .filter(({ required }) => required)
    .map(({ customFieldDefinitionId }) => customFieldDefinitionId)
    .filter((id) => !answered(additionalInformation[id]))

  const phoneValid = !includePhone || evaluatePhone(state, quote).valid

  return {
    valid: phoneValid && missingFieldIds.length === 0,
    missingFieldIds,
    phoneValid,
  }
}
